const filters = {
    // 手机号脱敏
    desMobile (str) {
        if (!str) {
            return ''
        }
        let pattern = /(\d{3})\d*(\d{4})/
        return str.replace(pattern, '$1****$2');
    },
    // 身份证脱敏
    desIdCard (str) {
        if (!str) {
            return ''
        }
        let pattern = /(\d{6})\d*(\d{4})/
        return str.replace(pattern, '$1********$2');
    }
}

export default filters